import React from "react";

interface CustomTextareaProps {
  label?: string;
  value?: string;
  placeholder?: string;
  required?: boolean;
  rows?: number;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  error?: string;
  className?: string;
}

const CustomTextarea: React.FC<CustomTextareaProps> = ({
  label,
  value = "",
  placeholder = "",
  required = false,
  rows = 3,
  onChange,
  error,
  className = "",
}) => {
  return (
    <label className="block mb-4 w-full">
      {label && (
        <span className="block text-sm font-medium text-gray-700 pb-1">
          {label}
        </span>
      )}

      <textarea
        value={value}
        required={required}
        onChange={onChange}
        placeholder={placeholder}
        aria-label={!label ? placeholder || undefined : undefined}
        rows={rows}
        className={`
          w-full p-3 border border-[#00000033] rounded-md resize-none
          focus:outline-none focus:ring-1 text-[#90A1B9]
          ${error ? "border-red-500 focus:ring-red-500" : "focus:ring-blue-500"}
          ${className}
        `}
      />

      {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
    </label>
  );
};

export default CustomTextarea;
